import { ModuleNameToModuleRegistry } from '../../types/types';
import { AudienceCollectUserTopBarFull } from './components/AudienceCollectUserTopBarFull';
import { UseCaseMarketResearchTopBarFull } from './components/UseCaseMarketResearchTopBarFull';
import { UseCaseOtherTopBarFull } from './components/UseCaseOtherTopBarFull';
import { AudienceUpsellRotation2TopBarFull } from './components/AudienceUpsellRotation2TopBarFull';
import { AudienceUpsellRotationTopBarFull } from './components/AudienceUpsellRotationTopBarFull';
import { BasicPendingInvoiceTopBarFull } from './components/BasicPendingInvoiceTopBarFull';
import { HasOverageTopBarFull } from './components/HasOverageTopBarFull';
import { InRetryTopBarFull } from './components/InRetryTopBarFull';
import { MsftTeamsIntegrationTopBarFull } from './components/MsftTeamsIntegrationTopBarFull';
import { UseCaseAcademicResearchTopBarFull } from './components/UseCaseAcademicResearchTopBarFull';
import { UseCaseCustomerSatisfactionTopBarFull } from './components/UseCaseCustomerSatisfactionTopBarFull';
import { UseCaseEmployeeEngagementTopBarFull } from './components/UseCaseEmployeeEngagementTopBarFull';
import { UseCaseEventFeedbackTopBarFull } from './components/UseCaseEventFeedbackTopBarFull';
import { UseCaseFormsApplicationsTopBarFull } from './components/UseCaseFormsApplicationsTopBarFull';
import { UseCasePerformanceEvaluationTopBarFull } from './components/UseCasePerformanceEvaluationTopBarFull';
import { UseCasePlanningRegistrationTopBarFull } from './components/UseCasePlanningRegistrationTopBarFull';
import { UseCaseQuizzesAssessmentsTopBarFull } from './components/UseCaseQuizzesAssessmentsTopBarFull';
import { UseCaseBallotVotingTopBarFull } from './components/UseCaseBallotVotingTopBarFull';
import { UseCaseCourseTrainingFeedbackTopBarFull } from './components/UseCaseCourseTrainingFeedbackTopBarFull';
import { UseCaseJustForFunTopBarFull } from './components/UseCaseJustForFunTopBarFull';
import { UseCaseStudentCommunityFeedbackTopBarFull } from './components/UseCaseStudentCommunityFeedbackTopBarFull';

const topBarFulls: Readonly<ModuleNameToModuleRegistry> = Object.freeze({
  collect_mr_user_audience_top_bar_full: AudienceCollectUserTopBarFull,
  use_case_market_research_top_bar_full: UseCaseMarketResearchTopBarFull,
  use_case_other_top_bar_full: UseCaseOtherTopBarFull,
  upsell_rotation_audience2_top_bar_full: AudienceUpsellRotation2TopBarFull,
  upsell_rotation_audience_top_bar_full: AudienceUpsellRotationTopBarFull,
  basic_pending_invoice_top_bar_full: BasicPendingInvoiceTopBarFull,
  has_overage_top_bar_full: HasOverageTopBarFull,
  in_retry_top_bar_full: InRetryTopBarFull,
  ucs_1116_msft_teams_integration_banner: MsftTeamsIntegrationTopBarFull,
  use_case_academic_research_top_bar_full: UseCaseAcademicResearchTopBarFull,
  use_case_customer_satisfaction_top_bar_full: UseCaseCustomerSatisfactionTopBarFull,
  use_case_employee_engagement_top_bar_full: UseCaseEmployeeEngagementTopBarFull,
  use_case_event_feedback_top_bar_full: UseCaseEventFeedbackTopBarFull,
  use_case_forms_applications_top_bar_full: UseCaseFormsApplicationsTopBarFull,
  use_case_performance_evaluation_top_bar_full: UseCasePerformanceEvaluationTopBarFull,
  use_case_planning_registration_top_bar_full: UseCasePlanningRegistrationTopBarFull,
  use_case_quizzes_assessments_top_bar_full: UseCaseQuizzesAssessmentsTopBarFull,
  use_case_student_community_feedback_top_bar_full: UseCaseStudentCommunityFeedbackTopBarFull,
  use_case_course_training_feedback_top_bar_full: UseCaseCourseTrainingFeedbackTopBarFull,
  use_case_ballot_voting_top_bar_full: UseCaseBallotVotingTopBarFull,
  use_case_just_for_fun_top_bar_full: UseCaseJustForFunTopBarFull,
});

export default topBarFulls;
